import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'

// Perguntas pré-definidas que botões da plataforma mandam ao chat da IA. O
// texto (prompt) vive no backend (`core/perguntas_predefinidas.py`); o front
// só conhece a chave e envia o texto devolvido como a pergunta do usuário.
export const PERGUNTA_RESUMO_NAO_LIDAS = 'resumo_nao_lidas'

class APIPerguntasPredefinidas extends APITemplate {
  // 200 -> { chave, texto }; 404 no corpo para chave desconhecida.
  async obter(chave) {
    const r = await con.get(intelligenceV2.perguntaPredefinida(chave))
    return r || this.buildErrorResponse({ message: 'Erro inesperado' })
  }
}

export const apiPerguntasPredefinidas = new APIPerguntasPredefinidas()
